import { z } from "zod";

/**
 * Per-facility feature flags, toggled by the super-admin. Stored in
 * clinics.feature_flags (jsonb). Resolution is DEFAULT-ENABLED: a feature is
 * on unless explicitly set to false — so existing tenants keep every feature,
 * and the admin turns one OFF to withhold it from a given account (e.g. a
 * cheaper plan). Only flags listed here are surfaced in the admin UI.
 */
export const FEATURE_FLAGS = [
	"ai_interpretation",
	"voice_assistant",
	"analytics",
] as const;
export type FeatureFlag = (typeof FEATURE_FLAGS)[number];

export const FEATURE_LABELS: Record<FeatureFlag, { ar: string; en: string }> = {
	ai_interpretation: {
		ar: "التفسير الذكي للنتائج (AI)",
		en: "AI result interpretation",
	},
	voice_assistant: { ar: "المساعد الذكي", en: "AI assistant" },
	analytics: { ar: "التحليلات والإحصائيات", en: "Analytics" },
};

/** A feature is enabled unless explicitly disabled (false). Default = enabled. */
export function isFeatureEnabled(
	flags: Record<string, boolean> | null | undefined,
	key: FeatureFlag,
): boolean {
	return flags?.[key] !== false;
}

export const adminSetFeatureFlagSchema = z.object({
	key: z.enum(FEATURE_FLAGS),
	enabled: z.boolean(),
});
export type AdminSetFeatureFlagInput = z.infer<
	typeof adminSetFeatureFlagSchema
>;
